import React from 'react'
import NotebookViewer from '../components/notebook-viewer/NotebookViewer.jsx'
import { graphql } from 'gatsby'
import Layout from '../components/layout.js'
import Masthead from '../components/masthead/Masthead.jsx'
import LauderHeader from '../components/lauderHeader/lauderHeader.jsx'
import { ViewerContext } from '../components/context/ViewerContext.jsx'
class catalogTemplate extends React.Component {
	render() {
		const data = this.props.data.catalogJson
		return (
			<Layout>
				<LauderHeader></LauderHeader>
				<ViewerContext.Consumer>
					{value => (
						<Masthead
							current="catalog"
							showCatalog={true}
							showCatalogMenu={true}
							showModeViewer={false}
							showTitle={false}
							toggledSetting={value.state.toggledSetting}
							updateToggledSetting={value.updateToggle}
						/>
					)}
				</ViewerContext.Consumer>
				<div className="exhibition-viewer">
					<NotebookViewer
						viewerType="catalog"
						currentView={this.props.location.pathname}
						folioNum={data.uid}
						tilePrefix="Catalogue"
					/>
				</div>
			</Layout>
		)
	}
}

export default catalogTemplate
export const query = graphql`
	query cataloguePageQuery($uid: Int!) {
		catalogJson(uid: { eq: $uid }) {
			uid
		}
	}
`
